import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SunriseIcon, ShirtIcon, BatteryWarningIcon } from 'lucide-react';
import { BotanicalLeaf } from './BotanicalLeaf';
const painPoints = [{
  icon: <MoonIcon className="w-8 h-8 text-sage" data-id="element-193" />,
  title: 'Vientre hinchado al final del día',
  description: 'Te levantas plana pero terminas el día sintiendo que tienes meses de embarazo.'
}, {
  icon: <SunriseIcon className="w-8 h-8 text-sage" data-id="element-194" />,
  title: 'Rigidez al despertar',
  description: "Tus articulaciones crujen y duelen por las mañanas, necesitando tiempo para 'calentar'."
}, {
  icon: <ShirtIcon className="w-8 h-8 text-sage" data-id="element-195" />,
  title: 'Ropa que aprieta de noche',
  description: 'Ese pantalón que te quedaba perfecto en la mañana, ahora te corta la respiración.'
}, {
  icon: <BatteryWarningIcon className="w-8 h-8 text-sage" data-id="element-196" />,
  title: 'Sensación de pesadez',
  description: 'Una fatiga constante y pesadez en el cuerpo que no se va, sin importar cuánto duermas.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PainSection() {
  return <section className="py-24 relative bg-white/50" data-id="element-197">
      <div className="absolute top-0 left-10 text-mint opacity-20 w-24 h-48 transform -scale-x-100" data-id="element-198">
        <BotanicalLeaf data-id="element-199" />
      </div>

      <div className="container mx-auto px-6 max-w-5xl" data-id="element-200">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-202">
            ¿Reconoces esto?
          </h2>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-203">
            La inflamación no es exceso de grasa, es una respuesta de auxilio de
            tu cuerpo. No estás imaginando estos síntomas.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-204">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-cream p-8 rounded-2xl border border-sage/10 shadow-sm hover:shadow-md transition-shadow duration-300 flex gap-6 items-start" data-id="element-205">
              <div className="bg-white p-4 rounded-xl shadow-sm shrink-0" data-id="element-206">
                {point.icon}
              </div>
              <div data-id="element-207">
                <h3 className="text-xl font-serif font-semibold mb-2" data-id="element-208">
                  {point.title}
                </h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-209">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}